import { i18n } from "../i18n/i18n";

import React, { Component } from 'react'
import Card from '../components/Card'
import Heading from '../components/Heading'

interface BillOfLadingGenerateCustomerProps {
  shipOrder: string
  name: string
  address: string
  city: string
  state: string
  zip: string
}

export default class BillOfLadingGenerateCustomer
  extends Component<BillOfLadingGenerateCustomerProps> {
  render () {
    return (
      <Card>
        <div className="text-base font-medium mb-2">
          <span className="mr-2">Ship Order</span>
          <span className="text-secondary">{this.props.shipOrder}</span>
        </div>
        <Heading
          className="mb-1"
          text={i18n("Customer")} />
        <div className="text-secondary">
          <p>{this.props.name}</p>
          <p>{this.props.address}</p>
          <p>
            {this.props.city}, {this.props.state} {this.props.zip}
          </p>
        </div>
      </Card>
    )
  }
}
